/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function($) {
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    });

  $(".twm_menu .twimenu").on("mouseover", function () {
    var h=$(this).attr('data-handle');
    $('.megatwm').hide();
    $('.'+h+'_megatwm').show();
  });

  
    if($(window).width() < 768) {
        $('.Header__FlexItem--link .Drawer__Open').click(function() {
            $('#sidebar-menu').attr('aria-hidden', false);
            $('.PageOverlay').addClass('is-visible');
        });

        $('#sidebar-menu .Drawer__Close').on('click', function() {
            $('#sidebar-menu').attr('aria-hidden', true);
            $('.PageOverlay').removeClass('is-visible');
        });
    } else {
        $('.Header__FlexItem--link').hover(function() {
            $('#sidebar-menu').attr('aria-hidden', false);
        }, function() {
            $('#sidebar-menu').attr('aria-hidden', true);
        });
    }

    $(document).ready(function() {
        $('.article-slider-wrapper').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 3000
        });

        $('.article-action-buttons .scroll-top-button a').on('click', function() {
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
            });
        });

        $('.product-special-infos .info-item').each(function(index) {
            $(this).on('click', function() {
                
                var dataIInfo = $(this).data('info');

                $('.product-infos-modal').addClass('hidden');
                $('.product-infos-modal__wrapper').addClass('hidden');
                $('.product-infos-modal--overlay').addClass('hidden');

                $('.product-infos-modal').each(function(index) {
                    if($(this).data('info') == dataIInfo) {
                        $(this).removeClass('hidden');
                        $('.product-infos-modal__wrapper').removeClass('hidden');
                        $('.product-infos-modal--overlay').removeClass('hidden');
                    }
                });
            });
        });

        $('.product-infos-modal .close-modal').on('click', function() {
            $('.product-infos-modal').addClass('hidden');
            $('.product-infos-modal__wrapper').addClass('hidden');
            $('.product-infos-modal--overlay').addClass('hidden');
        });

        /**
         * Upsell products
         */

        $('.upsell-products__item .ProductItem__Wrapper').each(function(index) {
            $(this).on('click', function(e) {
                e.preventDefault();
                var productInfo = $.parseJSON($(this).next().text());
                
                var productImages = productInfo.product.images;
                var productTitle = productInfo.product.title;
                var productPrice = productInfo.product.price / 100;
                // var productDescription = productInfo.product.description;
                var productId = productInfo.product.id;
                var productOptions = productInfo.product.options;
                var selectedVariantId = productInfo.selected_variant_id;
                var variants = productInfo.product.variants;
                
                var productImageHTML = "";
                var productMetaInfoHTML = "";

                for(var i = 0; i < productImages.length; i++) {
                    productImageHTML += "<div class='product-image'><img class='Image--fadeIn Image--lazyLoaded' src='" + productImages[i] + "'></div>";
                }

                $('.product-image-wrapper').html(productImageHTML);

                productMetaInfoHTML += "<h1 class='ProductMeta__Title Heading u-h4'>" + productTitle + "</h1>";
                productMetaInfoHTML += "<div class='ProductMeta__PriceList Heading'><span class='ProductMeta__Price Price Text--subdued u-h4'>" + USDollar.format(productPrice) + "</span></div>";
                // productMetaInfoHTML += "<div class='ProductMeta__Description'>" + productDescription + "</div>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .ProductMeta').html(productMetaInfoHTML);

                var productAddToCartForm = "<form method='post' class='upsell-product-form' action='/cart/add' id='product_form_" + productId + "' accept-charset='UTF-8' enctype='multipart/form-data'>";
                productAddToCartForm += "<input type='hidden' name='product-id' value='" + productId + "'>";
                productAddToCartForm += "<input type='hidden' name='quantity' value='1'>";
                productAddToCartForm += "<input type='hidden' name='id' value='" + selectedVariantId + "'>";
                productAddToCartForm += "<div class='ProductForm__Variants'>";

                for (var j = 0; j < productOptions.length; j++) {
                    var optionName = productOptions[j];
                    var selectedColorValue = "";
                    var selectedSizeValue = "";
                    var colorOptionClass = "";
                    
                    for (var k = 0; k < variants.length; k++) {
                        if (selectedVariantId === variants[k].id) {
                            if (optionName == 'Color') {
                                selectedColorValue = variants[k].options[0];
                                colorOptionClass = "ProductForm__Label__Color";
                            } else {
                                selectedSizeValue = variants[k].options[1];
                            }
                        }
                    }

                    productAddToCartForm += "<span class='ProductForm__Label " + colorOptionClass + "'>" + optionName + ": " + selectedColorValue;
                    productAddToCartForm += "</span>";

                    if (optionName == 'Color') {
                        productAddToCartForm += "<ul class='ColorSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var colorOptions = [];
                        var colorSwatchImages = [];

                        for (var x = 0; x < variants.length; x++) {
                            colorOptions.push(variants[x].options[0]);
                            colorSwatchImages.push(variants[x].featured_image.src);
                        }
                        
                        var newSetColorOptions = new Set(colorOptions);
                        var newSetColorOptions1 = [...newSetColorOptions];

                        var newSetColorSwarchImages = new Set(colorSwatchImages);
                        var newSetColorSwarchImages1 = [...newSetColorSwarchImages];

                        for (var y = 0; y < newSetColorOptions1.length; y++) {
                            var checkedColorValue = "";

                            if (selectedColorValue == newSetColorOptions1[y]) {
                                checkedColorValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "' class='ColorSwatch__Radio' name='option-1' value='" + newSetColorOptions1[y] + "' data-option-position='" + (j + 1) + "' " + checkedColorValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "' class='ColorSwatch ColorSwatch--large' style='background-image: url(" + newSetColorSwarchImages1[y] + ")'><span class='u-visually-hidden'>" + newSetColorOptions1[y] + "</span></label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    } else {
                        productAddToCartForm += "<ul class='SizeSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var sizeOptions = [];

                        for (var x = 0; x < variants.length; x++) {
                            sizeOptions.push(variants[x].options[1]);
                        }

                        var newSetSizeOptions = new Set(sizeOptions);
                        var newSetSizeOptions1 = [...newSetSizeOptions];

                        for (var y = 0; y < newSetSizeOptions1.length; y++) {
                            var checkedSizeValue = "";

                            if (selectedSizeValue == newSetSizeOptions1[y]) {
                                checkedSizeValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item' data-color='" + selectedColorValue + "'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch__Radio' name='option-2' value='" + newSetSizeOptions1[y] + "' data-option-position='" + (j + 2) + "' " + checkedSizeValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch'>" + newSetSizeOptions1[y] + "</label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    }
                }

                var variantAvailable = false;
                var addToCartBttonClass = "Button--secondary";
                var addToCartBttonAction = "disabled='disabled'";
                var addToCartBttonText = "Sold Out";

                for (var z = 0; z < variants.length; z++) {
                    if (variants[z].id == selectedVariantId) {
                        if(variants[z].available == true) {
                            variantAvailable = true
                        }
                    }
                }

                if (variantAvailable == true) {
                    addToCartBttonClass = "Button--primary";
                    addToCartBttonAction = "data-action='add-to-cart-upsell'";
                    addToCartBttonText = "Add To Cart";
                }

                productAddToCartForm += "<button class='ProductForm__AddToCart__Upsell Button " + addToCartBttonClass + " Button--full' " + addToCartBttonAction + "><span>" + addToCartBttonText + "</span></button>";
                productAddToCartForm += "</div>";
                productAddToCartForm += "</form>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .productForm__Wrapper').html(productAddToCartForm);
                
                setTimeout(function() {
                    $('.QuickShopDrawer').addClass('active');
                    $('.QuickShopDrawer-overlay').removeClass('hidden');
                    $('body.template-product').addClass('scroll-lock');

                    $('.upsell-product-form input[type=radio][name=option-1]').change(function() {
                        var checkedColorValue = $(this).val();
                        var checkedSizeValue = "";
                        var variantAvailable = false;

                        if ($('.upsell-product-form input[type=radio][name=option-2]')) {
                            checkedSizeValue = $('.upsell-product-form input[type=radio][name=option-2]:checked').val();
                        }

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);
                        $('.upsell-product-form .ProductForm__Label__Color').text("Color: " + checkedColorValue);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.upsell-product-form input[type=radio][name=option-2]').change(function() {
                        var checkedSizeValue = $(this).val();
                        var checkedColorValue = $('.upsell-product-form input[type=radio][name=option-1]:checked').val();
                        var variantAvailable = false;

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });
                }, 100);
            });
        });

        /**
         * 2 column featured products
         */

        $('.two-column-featured-products-container .image-item-link__product-link').each(function(index) {
            $(this).on('click', function(e) {
                e.preventDefault();

                var productInfo = $.parseJSON($(this).next().text());

                var productImages = productInfo.product.images;
                var productTitle = productInfo.product.title;
                var productPrice = productInfo.product.price / 100;
                // var productDescription = productInfo.product.description;
                var productId = productInfo.product.id;
                var productOptions = productInfo.product.options;
                var selectedVariantId = productInfo.selected_variant_id;
                var variants = productInfo.product.variants;
                
                var productImageHTML = "";
                var productMetaInfoHTML = "";

                for(var i = 0; i < productImages.length; i++) {
                    productImageHTML += "<div class='product-image'><img class='Image--fadeIn Image--lazyLoaded' src='" + productImages[i] + "'></div>";
                }

                $('.product-image-wrapper').html(productImageHTML);

                productMetaInfoHTML += "<h1 class='ProductMeta__Title Heading u-h4'>" + productTitle + "</h1>";
                productMetaInfoHTML += "<div class='ProductMeta__PriceList Heading'><span class='ProductMeta__Price Price Text--subdued u-h4'>" + USDollar.format(productPrice) + "</span></div>";
                // productMetaInfoHTML += "<div class='ProductMeta__Description'>" + productDescription + "</div>";

                $('.selected-upsell-product-wrapper .ProductMeta').html(productMetaInfoHTML);

                var productAddToCartForm = "<form method='post' class='upsell-product-form' action='/cart/add' id='product_form_" + productId + "' accept-charset='UTF-8' enctype='multipart/form-data'>";
                productAddToCartForm += "<input type='hidden' name='product-id' value='" + productId + "'>";
                productAddToCartForm += "<input type='hidden' name='quantity' value='1'>";
                productAddToCartForm += "<input type='hidden' name='id' value='" + selectedVariantId + "'>";
                productAddToCartForm += "<div class='ProductForm__Variants'>";

                for (var j = 0; j < productOptions.length; j++) {
                    var optionName = productOptions[j];
                    var selectedColorValue = "";
                    var selectedSizeValue = "";
                    var colorOptionClass = "";
                    
                    for (var k = 0; k < variants.length; k++) {
                        if (selectedVariantId === variants[k].id) {
                            if (optionName == 'Color') {
                                selectedColorValue = variants[k].options[0];
                                colorOptionClass = "ProductForm__Label__Color";
                            } else {
                                selectedSizeValue = variants[k].options[1];
                            }
                        }
                    }

                    productAddToCartForm += "<span class='ProductForm__Label " + colorOptionClass + "'>" + optionName + ": " + selectedColorValue;
                    productAddToCartForm += "</span>";

                    if (optionName == 'Color') {
                        productAddToCartForm += "<ul class='ColorSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var colorOptions = [];
                        var colorSwatchImages = [];

                        for (var x = 0; x < variants.length; x++) {
                            colorOptions.push(variants[x].options[0]);
                            colorSwatchImages.push(variants[x].featured_image.src);
                        }
                        
                        var newSetColorOptions = new Set(colorOptions);
                        var newSetColorOptions1 = [...newSetColorOptions];

                        var newSetColorSwarchImages = new Set(colorSwatchImages);
                        var newSetColorSwarchImages1 = [...newSetColorSwarchImages];

                        for (var y = 0; y < newSetColorOptions1.length; y++) {
                            var checkedColorValue = "";

                            if (selectedColorValue == newSetColorOptions1[y]) {
                                checkedColorValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "' class='ColorSwatch__Radio' name='option-1' value='" + newSetColorOptions1[y] + "' data-option-position='" + (j + 1) + "' " + checkedColorValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "' class='ColorSwatch ColorSwatch--large' style='background-image: url(" + newSetColorSwarchImages1[y] + ")'><span class='u-visually-hidden'>" + newSetColorOptions1[y] + "</span></label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    } else {
                        productAddToCartForm += "<ul class='SizeSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var sizeOptions = [];

                        for (var x = 0; x < variants.length; x++) {
                            sizeOptions.push(variants[x].options[1]);
                        }

                        var newSetSizeOptions = new Set(sizeOptions);
                        var newSetSizeOptions1 = [...newSetSizeOptions];

                        for (var y = 0; y < newSetSizeOptions1.length; y++) {
                            var checkedSizeValue = "";

                            if (selectedSizeValue == newSetSizeOptions1[y]) {
                                checkedSizeValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item' data-color='" + selectedColorValue + "'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch__Radio' name='option-2' value='" + newSetSizeOptions1[y] + "' data-option-position='" + (j + 2) + "' " + checkedSizeValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch'>" + newSetSizeOptions1[y] + "</label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    }
                }

                var variantAvailable = false;
                var addToCartBttonClass = "Button--secondary";
                var addToCartBttonAction = "disabled='disabled'";
                var addToCartBttonText = "Sold Out";

                for (var z = 0; z < variants.length; z++) {
                    if (variants[z].id == selectedVariantId) {
                        if(variants[z].available == true) {
                            variantAvailable = true
                        }
                    }
                }

                if (variantAvailable == true) {
                    addToCartBttonClass = "Button--primary";
                    addToCartBttonAction = "data-action='add-to-cart-upsell'";
                    addToCartBttonText = "Add To Cart";
                }

                productAddToCartForm += "<button class='ProductForm__QuickShop ProductForm__AddToCart__Upsell Button " + addToCartBttonClass + " Button--full' " + addToCartBttonAction + "><span>" + addToCartBttonText + "</span></button>";
                productAddToCartForm += "</div>";
                productAddToCartForm += "</form>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .productForm__Wrapper').html(productAddToCartForm);
                
                setTimeout(function() {
                    $('.QuickShopDrawer').addClass('active');
                    $('.QuickShopDrawer-overlay').removeClass('hidden');
                    $('body.template-product').addClass('scroll-lock');

                    $('.upsell-product-form input[type=radio][name=option-1]').change(function() {
                        var checkedColorValue = $(this).val();
                        var checkedSizeValue = "";
                        var variantAvailable = false;

                        if ($('.upsell-product-form input[type=radio][name=option-2]')) {
                            checkedSizeValue = $('.upsell-product-form input[type=radio][name=option-2]:checked').val();
                        }

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);
                        $('.upsell-product-form .ProductForm__Label__Color').text("Color: " + checkedColorValue);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.upsell-product-form input[type=radio][name=option-2]').change(function() {
                        var checkedSizeValue = $(this).val();
                        var checkedColorValue = $('.upsell-product-form input[type=radio][name=option-1]:checked').val();
                        var variantAvailable = false;

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.ProductForm__QuickShop').on('click', function(e) {
                        e.preventDefault();

                        $(this).prop('disabled', true);
                        document.dispatchEvent(new CustomEvent('theme:loading:start'));

                        var form = $('.upsell-product-form');

                        var selectedVariantId = form.find('[name="id"]').val();
    
                        let formData = {
                            'items': [{
                                'id': selectedVariantId,
                                'quantity': 1
                             }]
                        };
                        
                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                            'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        })
                        .then(response => {
                            document.dispatchEvent(new CustomEvent('theme:loading:end'));
                            if (response['ok'] == true) {
                                $(this).prop('disabled', false);

                                document.dispatchEvent(new CustomEvent('product:added', {
                                    bubbles: true,
                                    detail: {
                                      variant: selectedVariantId,
                                      quantity: 1
                                    }
                                }));
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                    });
                }, 100);
            });
        });

        /**
         * Landscape featured products
         */
        $('.landscape-featured-products-container .image-item-link').each(function(index) {
            $(this).on('click', function(e) {
                e.preventDefault();
                
                var productInfo = $.parseJSON($(this).find('.image-item').next().text());

                var productImages = productInfo.product.images;
                var productTitle = productInfo.product.title;
                var productPrice = productInfo.product.price / 100;
                // var productDescription = productInfo.product.description;
                var productId = productInfo.product.id;
                var productOptions = productInfo.product.options;
                var selectedVariantId = productInfo.selected_variant_id;
                var variants = productInfo.product.variants;
                
                var productImageHTML = "";
                var productMetaInfoHTML = "";

                for(var i = 0; i < productImages.length; i++) {
                    productImageHTML += "<div class='product-image'><img class='Image--fadeIn Image--lazyLoaded' src='" + productImages[i] + "'></div>";
                }

                $('.product-image-wrapper').html(productImageHTML);

                productMetaInfoHTML += "<h1 class='ProductMeta__Title Heading u-h4'>" + productTitle + "</h1>";
                productMetaInfoHTML += "<div class='ProductMeta__PriceList Heading'><span class='ProductMeta__Price Price Text--subdued u-h4'>" + USDollar.format(productPrice) + "</span></div>";
                // productMetaInfoHTML += "<div class='ProductMeta__Description'>" + productDescription + "</div>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .ProductMeta').html(productMetaInfoHTML);

                var productAddToCartForm = "<form method='post' class='upsell-product-form' action='/cart/add' id='product_form_" + productId + "' accept-charset='UTF-8' enctype='multipart/form-data'>";
                productAddToCartForm += "<input type='hidden' name='product-id' value='" + productId + "'>";
                productAddToCartForm += "<input type='hidden' name='quantity' value='1'>";
                productAddToCartForm += "<input type='hidden' name='id' value='" + selectedVariantId + "'>";
                productAddToCartForm += "<div class='ProductForm__Variants'>";

                for (var j = 0; j < productOptions.length; j++) {
                    var optionName = productOptions[j];
                    var selectedColorValue = "";
                    var selectedSizeValue = "";
                    var colorOptionClass = "";
                    
                    for (var k = 0; k < variants.length; k++) {
                        if (selectedVariantId === variants[k].id) {
                            if (optionName == 'Color') {
                                selectedColorValue = variants[k].options[0];
                                colorOptionClass = "ProductForm__Label__Color";
                            } else {
                                selectedSizeValue = variants[k].options[1];
                            }
                        }
                    }

                    productAddToCartForm += "<span class='ProductForm__Label " + colorOptionClass + "'>" + optionName + ": " + selectedColorValue;
                    productAddToCartForm += "</span>";

                    if (optionName == 'Color') {
                        productAddToCartForm += "<ul class='ColorSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var colorOptions = [];
                        var colorSwatchImages = [];

                        for (var x = 0; x < variants.length; x++) {
                            colorOptions.push(variants[x].options[0]);
                            colorSwatchImages.push(variants[x].featured_image.src);
                        }
                        
                        var newSetColorOptions = new Set(colorOptions);
                        var newSetColorOptions1 = [...newSetColorOptions];

                        var newSetColorSwarchImages = new Set(colorSwatchImages);
                        var newSetColorSwarchImages1 = [...newSetColorSwarchImages];

                        for (var y = 0; y < newSetColorOptions1.length; y++) {
                            var checkedColorValue = "";

                            if (selectedColorValue == newSetColorOptions1[y]) {
                                checkedColorValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "' class='ColorSwatch__Radio' name='option-1' value='" + newSetColorOptions1[y] + "' data-option-position='" + (j + 1) + "' " + checkedColorValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "' class='ColorSwatch ColorSwatch--large' style='background-image: url(" + newSetColorSwarchImages1[y] + ")'><span class='u-visually-hidden'>" + newSetColorOptions1[y] + "</span></label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    } else {
                        productAddToCartForm += "<ul class='SizeSwatchList HorizontalList HorizontalList--spacingTight'>";

                        var sizeOptions = [];

                        for (var x = 0; x < variants.length; x++) {
                            sizeOptions.push(variants[x].options[1]);
                        }

                        var newSetSizeOptions = new Set(sizeOptions);
                        var newSetSizeOptions1 = [...newSetSizeOptions];

                        for (var y = 0; y < newSetSizeOptions1.length; y++) {
                            var checkedSizeValue = "";

                            if (selectedSizeValue == newSetSizeOptions1[y]) {
                                checkedSizeValue = "checked";
                            }

                            productAddToCartForm += "<li class='HorizontalList__Item' data-color='" + selectedColorValue + "'>";
                            productAddToCartForm += "<input type='radio' id='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch__Radio' name='option-2' value='" + newSetSizeOptions1[y] + "' data-option-position='" + (j + 2) + "' " + checkedSizeValue + ">";
                            productAddToCartForm += "<label for='option-upsell-product-template-" + y + "-" + newSetSizeOptions1[y] + "' class='SizeSwatch'>" + newSetSizeOptions1[y] + "</label>";
                            productAddToCartForm += "</li>";
                        }

                        productAddToCartForm += "</ul>";
                    }
                }

                var variantAvailable = false;
                var addToCartBttonClass = "Button--secondary";
                var addToCartBttonAction = "disabled='disabled'";
                var addToCartBttonText = "Sold Out";

                for (var z = 0; z < variants.length; z++) {
                    if (variants[z].id == selectedVariantId) {
                        if(variants[z].available == true) {
                            variantAvailable = true
                        }
                    }
                }

                if (variantAvailable == true) {
                    addToCartBttonClass = "Button--primary";
                    addToCartBttonAction = "data-action='add-to-cart-upsell'";
                    addToCartBttonText = "Add To Cart";
                }

                productAddToCartForm += "<button class='ProductForm__QuickShop ProductForm__AddToCart__Upsell Button " + addToCartBttonClass + " Button--full' " + addToCartBttonAction + "><span>" + addToCartBttonText + "</span></button>";
                productAddToCartForm += "</div>";
                productAddToCartForm += "</form>";

                $('.selected-upsell-product-wrapper .product-info-wrapper .productForm__Wrapper').html(productAddToCartForm);
                
                setTimeout(function() {
                    $('.QuickShopDrawer').addClass('active');
                    $('.QuickShopDrawer-overlay').removeClass('hidden');
                    $('body.template-product').addClass('scroll-lock');

                    $('.upsell-product-form input[type=radio][name=option-1]').change(function() {
                        var checkedColorValue = $(this).val();
                        var checkedSizeValue = "";
                        var variantAvailable = false;

                        if ($('.upsell-product-form input[type=radio][name=option-2]')) {
                            checkedSizeValue = $('.upsell-product-form input[type=radio][name=option-2]:checked').val();
                        }

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);
                        $('.upsell-product-form .ProductForm__Label__Color').text("Color: " + checkedColorValue);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.upsell-product-form input[type=radio][name=option-2]').change(function() {
                        var checkedSizeValue = $(this).val();
                        var checkedColorValue = $('.upsell-product-form input[type=radio][name=option-1]:checked').val();
                        var variantAvailable = false;

                        for (var a = 0; a < variants.length; a++) {
                            if (variants[a].option1 == checkedColorValue && variants[a].option2 == checkedSizeValue) {
                                selectedVariantId = variants[a].id;

                                if (variants[a].available == true) {
                                    variantAvailable = true;
                                }
                            }
                        }

                        $('.upsell-product-form input[name=id]').val(selectedVariantId);

                        if (variantAvailable == true) {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', false);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Add To Cart');
                        } else {
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').prop('disabled', true);
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').removeClass('Button--primary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell').addClass('Button--secondary');
                            $('.upsell-product-form .ProductForm__AddToCart__Upsell span').text('Sold Out');
                        }
                    });

                    $('.ProductForm__QuickShop').on('click', function(e) {
                        e.preventDefault();

                        $(this).prop('disabled', true);
                        document.dispatchEvent(new CustomEvent('theme:loading:start'));

                        var form = $('.upsell-product-form');

                        var selectedVariantId = form.find('[name="id"]').val();
    
                        let formData = {
                            'items': [{
                                'id': selectedVariantId,
                                'quantity': 1
                             }]
                        };
                        
                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                            'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        })
                        .then(response => {
                            document.dispatchEvent(new CustomEvent('theme:loading:end'));
                            if (response['ok'] == true) {
                                $(this).prop('disabled', false);

                                document.dispatchEvent(new CustomEvent('product:added', {
                                    bubbles: true,
                                    detail: {
                                      variant: selectedVariantId,
                                      quantity: 1
                                    }
                                }));
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                    });
                }, 100);
            });
        });

        $('.QuickShopDrawer .close-button').on('click', function() {
            $('.QuickShopDrawer').removeClass('active');
            $('.QuickShopDrawer-overlay').addClass('hidden');
            $('body.template-product').removeClass('scroll-lock');
        });
    })



    /**
     * Ajax Contact form
     */

    function CopyToClipboard(id)
    {
        var r = document.createRange();
        r.selectNode(document.getElementById(id));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(r);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        document.querySelector('.copied-message').style.display = "block";
        setTimeout(function(){
            document.querySelector('.copied-message').style.display = "none";
        }, 3000)
    }

    if(document.querySelector('.Alert--success .copy-icon')) {
        document.querySelector('.Alert--success .copy-icon').addEventListener('click', function () {
            CopyToClipboard('copy_clip');
        });
    }

    function formToJSON(elements) {
        return [].reduce.call(elements, function (data, element) {
            data[element.name] = element.value;
            return data;
        }, {});
    }
    
    // Get Shopify Friendly URL String
    function getUrlString(data) {
        var urlParameters = Object.entries(data).map(function (e) {
            return e.join('=');
        }).join('&');
    
        return urlParameters;
    }
    
    function ajaxFormInit(form) {
        var form_type = form.querySelector("[name=form_type]").value,
            inputs = form.querySelectorAll("[name]"),
            alert = form.querySelector('[data-alert="status"]'),
            alert_msgs = form.querySelector('.Form__Alert');
    
        form.addEventListener('submit', function(e){
            e.preventDefault();
    
            var action = form.getAttribute("action");
    
            fetch(action, {
                method: 'POST',
                body: getUrlString(formToJSON(inputs)),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Accept': 'text/html, */*; q=0.01',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function(response) {
                console.log(response);
                console.log(response.status);
    
                if (alert) {
                    console.log("alert: " + alert);
                    alert.className = "Alert Alert-success";
                    // alert.innerHTML = alert_msg.success;
                }
                
                form.querySelector('input').style.display = "none";
                form.querySelector('input[type=email]').style.display = "none";
                form.querySelector('.select-people-items').style.display = "none";
                form.querySelector('.Form__Submit').style.display = "none";
                document.querySelector('.popup-image').style.display = "none";
                document.querySelector('.NewsletterPopup__Content').style.display = "none";
                
                alert_msgs.style.display = "block";

            }).catch(function(err) {
                console.error(err);
    
                if (alert) {
                    alert.className = "alert alert-error";
                    alert.innerHTML = alert_msg.error;
                }
            });
        });
    }
    
    // Init Shopify Forms
    document.querySelectorAll("[name=form_type]").forEach(function(el) {
        ajaxFormInit(el.closest("form"));
    });
})(jQuery);